import React, { useState, useEffect } from "react";
import { LOADS as MOCK_LOADS } from "../mock";
import { MapPin, ChevronDown } from "lucide-react";
import api from "../lib/api";

const DetailRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="detail-item">
      <span className="detail-label">{label}</span>
      <span className="detail-value">{value}</span>
    </div>
  );
};

const LoadBoard = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [LOADS, setLOADS] = useState(MOCK_LOADS);

  useEffect(() => {
    api.get("/loads")
      .then((r) => { if (Array.isArray(r.data) && r.data.length > 0) setLOADS(r.data); })
      .catch(() => { /* keep mock fallback */ });
  }, []);

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section className="loadboard" id="loadboard">
      <div className="container">
        <div className="section-head">
          <span className="kicker">Available Freight</span>
          <h2>This week's open loads</h2>
          <p>A sample of what's currently on our board. Click any load to view full details, or submit the form below to get matched with a load that fits your equipment and lane.</p>
        </div>

        <div className="board-wrap">
          <div className="board-top">
            <span className="live"><span className="dot"></span>Live Load Board</span>
            <span style={{ fontSize: "12px", color: "var(--grey-300)" }}>Updated daily &mdash; call for full list</span>
          </div>
          <div className="board-scroll">
            <table className="load-table">
              <thead>
                <tr>
                  <th>Route</th>
                  <th>Equipment</th>
                  <th>Miles</th>
                  <th>Pickup</th>
                  <th>Rate</th>
                  <th aria-label="Expand"></th>
                </tr>
              </thead>
              <tbody>
                {LOADS.map((load, i) => {
                  const isOpen = openIndex === i;
                  const d = load.details || {};
                  return (
                    <React.Fragment key={i}>
                      <tr
                        className={`load-row ${isOpen ? "is-open" : ""}`}
                        onClick={() => toggle(i)}
                      >
                        <td>
                          <div className="route-cell">
                            <MapPin />
                            {load.origin} &rarr; {load.destination}
                          </div>
                        </td>
                        <td><span className="tag">{load.equipment}</span></td>
                        <td>{load.miles} mi</td>
                        <td>{load.pickup}</td>
                        <td className="rate">{load.rate}</td>
                        <td className="expand-cell">
                          <ChevronDown className={`chev ${isOpen ? "rot" : ""}`} />
                        </td>
                      </tr>
                      {isOpen && (
                        <tr className="detail-row">
                          <td colSpan={6}>
                            <div className="load-details">
                              <div className="detail-grid">
                                <DetailRow label="Commodity" value={d.commodity} />
                                <DetailRow label="Weight" value={d.weight} />
                                <DetailRow label="Trailer" value={d.trailer} />
                                <DetailRow label="Pickup" value={load.pickup} />
                                <DetailRow label="Delivery" value={d.delivery} />
                                <DetailRow label="Miles" value={`${load.miles} mi`} />
                                <DetailRow label="Rate" value={d.pay || load.rate} />
                                <DetailRow label="Dispatch Fee" value={d.dispatchFee} />
                              </div>
                              {d.requirements && d.requirements.length > 0 && (
                                <div className="detail-req">
                                  <span className="detail-label">Requirements</span>
                                  <ul>
                                    {d.requirements.map((r, ri) => (
                                      <li key={ri}>{r}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                              {d.note && <p className="detail-note">{d.note}</p>}
                              <a href="#contact" className="btn btn-primary detail-cta">Book This Load</a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="board-foot">
            Want your available truck matched to a load like these?{" "}
            <a href="#contact" style={{ color: "var(--green-500)", fontWeight: 600 }}>Contact dispatch &rarr;</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoadBoard;
